export default "__VITE_ASSET__C4kW2w6Y__"